import styled from "styled-components";
import { NoticeInfo } from "api/interfaces/noticeInterface.interface";
import { NoticeBar } from "./NoticeBar";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getCookie, setCookie } from "cookies/cookie";
import { deleteNotice, setNotices } from "redux/reducers/notices/noticeReducer";
import { getAuthNotices } from "api/authAPI";
import { useQuery } from "react-query";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import HiddenWarningBar from "./HiddenWarningBar";
import { useEffect, useRef } from "react";
import { useNoticeHeight } from "components/NoticePovider";
import VersionRefreshBar from "./VersionRefreshBar";
import { ReleaseVersion } from "api/interfaces/releaseInterface.interface";
import { useAuth } from "components/Auth";
import { useLocation } from "react-router-dom";

export function Notice(): JSX.Element {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const notices: NoticeInfo[] = useAppSelector((state) => state.notice.notices);
  const release: ReleaseVersion = useAppSelector(
    (state) => state.notice.release
  );
  const { user } = useAuth();
  const noticeHeightRef = useRef<HTMLDivElement>(null);
  const { setNoticeHeight } = useNoticeHeight();

  const noticeCookieOptions = {
    path: "/",
  };
  const { isLoading } = useQuery(["getAuthNotice"], () => getAuthNotices(), {
    refetchOnWindowFocus: false,
    onSuccess: (res: any) => {
      // console.log(res, "getAuthNotice");
      let tempNotices: NoticeInfo[] = res.filter(
        (r: any) =>
          getCookie(`notice-${r.noticeId}`) === undefined &&
          getCookie(`notice-${r.noticeId}`) !== 1
      );
      dispatch(setNotices(tempNotices));
    },
    onError: (e: any) => {},
  });

  const onCloseNotice = (notice: NoticeInfo) => {
    // console.log(notice);
    if (!notice.preview) {
      setCookie({
        name: `notice-${notice.noticeId}`,
        value: 1,
        options: {
          ...noticeCookieOptions,
          expires: new Date(notice.enableEndTime),
        },
      });
      dispatch(deleteNotice(notice.noticeId));
    }
  };

  useEffect(() => {
    const getNoticeHeight = () => {
      setNoticeHeight(
        noticeHeightRef.current ? noticeHeightRef.current?.clientHeight : 0
      );
    };
    getNoticeHeight();
    window.addEventListener("resize", getNoticeHeight);
    return () => {
      window.removeEventListener("resize", getNoticeHeight);
    };
  }, [
    selectedAccount,
    noticeHeightRef,
    notices,
    release.needToUpdate,
    user.userId,
    location.pathname,
  ]);

  if (isLoading) {
    return <></>;
  }
  return (
    <NoticeWrapper ref={noticeHeightRef}>
      {notices.map((notice: NoticeInfo, index: number) => {
        return (
          !notice.disabled && (
            <NoticeBar
              key={index}
              message={notice.message}
              color={notice.color}
              type={notice.icon}
              onClickClose={() => onCloseNotice(notice)}
            />
          )
        );
      })}
      {selectedAccount.isHidden && user.userId && <HiddenWarningBar />}
      {release.needToUpdate && <VersionRefreshBar />}
    </NoticeWrapper>
  );
}
const NoticeWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 990;
`;
